import { useEffect, useState } from "react";
import { Flex, Text } from "@twilio-paste/core";

const STATUS = {
    initializing: {
        color: "rgba(2, 99, 224, 0.35)",
        pulse: true,
        label: "Initializing",
    },
    ready: {
        color: "rgb(14, 168, 76)",
        pulse: false,
        label: "Ready",
    },
    calling: {
        color: "rgb(2, 99, 224)",
        pulse: true,
        label: null,
    },
    connected: {
        color: "rgb(14, 168, 76)",
        pulse: false,
        label: "Connected",
    },
};

const containerStyle = {
    display: "inline-flex",
    alignItems: "center",
    gap: "10px",
    padding: "6px 14px",
    borderRadius: "20px",
    background: "rgba(245, 248, 252, 0.7)",
    backdropFilter: "blur(4px)",
    WebkitBackdropFilter: "blur(4px)",
};

const dotOuter = (color, pulse) => ({
    width: "10px",
    height: "10px",
    borderRadius: "50%",
    backgroundColor: color,
    flexShrink: 0,
    position: "relative",
    boxShadow: `0 0 0 0 ${color}`,
    animation: pulse ? "statusPulse 1.8s ease-in-out infinite" : "none",
});

function CallStatusMessage({ voiceDevice, currentCallInfo }) {
    const [status, setStatus] = useState("initializing");
    const [detail, setDetail] = useState("");

    useEffect(() => {
        if (voiceDevice && !currentCallInfo) {
            setStatus("ready");
            setDetail("");
        }

        if (voiceDevice && currentCallInfo) {
            if (currentCallInfo._wasConnected) {
                setStatus("connected");
                setDetail("");
            } else if (currentCallInfo._direction === "OUTGOING") {
                setStatus("calling");
                setDetail(currentCallInfo._options.twimlParams.to);
            } else {
                setStatus("calling");
                setDetail(currentCallInfo.parameters.From);
            }
        }
    }, [voiceDevice, currentCallInfo]);

    const cfg = STATUS[status];
    const displayLabel = cfg.label || (status === "calling"
        ? (currentCallInfo?._direction === "INCOMING" ? "Incoming" : "Calling")
        : cfg.label);

    return (
        <>
            <style>{`
                @keyframes statusPulse {
                    0%, 100% { box-shadow: 0 0 0 0 currentColor; opacity: 1; }
                    50% { box-shadow: 0 0 0 5px transparent; opacity: 0.6; }
                }
            `}</style>
            <Flex hAlignContent={"center"} vAlignContent={"center"}>
                <div style={containerStyle}>
                    <div style={{ ...dotOuter(cfg.color, cfg.pulse), color: cfg.color }} />
                    <Text
                        as={"span"}
                        fontSize="fontSize20"
                        fontWeight="fontWeight500"
                        color="colorText"
                        lineHeight="1"
                    >
                        {displayLabel}
                    </Text>
                    {detail && (
                        <Text
                            as={"span"}
                            fontSize="fontSize20"
                            fontWeight="fontWeight400"
                            color="colorTextWeak"
                            lineHeight="1"
                        >
                            {detail}
                        </Text>
                    )}
                </div>
            </Flex>
        </>
    );
}

export default CallStatusMessage;
